import { useTranslation } from '@frontend/i18n';
import { Modal, Text } from '@frontend/design-system';

type ResultProps = {
  totalSuccessCount: number;
  changedBalanceSuccessCount: number;
  totalChangedBalanceCount: number;
  failedCount: number;
  totalCount: number;
  onClose: () => void;
};
export const Result = ({
  totalSuccessCount,
  changedBalanceSuccessCount,
  totalChangedBalanceCount,
  failedCount,
  totalCount,
  onClose,
}: ResultProps) => {
  const { t } = useTranslation('payments');

  return (
    <>
      <Modal.Body>
        <ul>
          <li>
            <Text>
              {totalSuccessCount}/{totalCount} {t('New payment requests successfully created')}
            </Text>
          </li>
          {!!totalChangedBalanceCount && (
            <li>
              <Text>
                {changedBalanceSuccessCount}/{totalChangedBalanceCount}{' '}
                {t('Successfully replaced payment requests for changed balances')}
              </Text>
            </li>
          )}
          {!!failedCount && (
            <li>
              <Text>
                {failedCount} {t('Failed to create payment requests')}
              </Text>
            </li>
          )}
        </ul>
        <Text>{t('It may take a few moments for requests to populate or update')}</Text>
      </Modal.Body>
      <Modal.Footer
        primary={{
          label: t('Done'),
          onClick: onClose,
        }}
      />
    </>
  );
};
